import React, { memo } from 'react';

import { translate } from '../../common/translation/translate';
import { WidgetProps } from '../common/interfaces/types';
import { CommonWidgetContainer } from '../common/widgets/commonWidgetStyle';
import { CommonWidgetHeader } from '../common/widgets/commonWidgetHeader';
import { FeaturedVideosWidgetBody } from './featuredVideosWidgetBody';
import { getWidgetHeaderText } from '../../common/utilities/getWidgetHeaderUtil';

interface FeaturedVideosWidgetViewProps extends WidgetProps {
    enableVideoLandingPageOnWeb2?: boolean;
}
export const FeaturedVideosWidgetView = memo(({ widgetLinkURL, handleWidgetClick, enableVideoLandingPageOnWeb2 }: FeaturedVideosWidgetViewProps) => {
    if (enableVideoLandingPageOnWeb2) {
        return (
            <CommonWidgetContainer href={widgetLinkURL} target='_self'  onClick={handleWidgetClick}> 
                <CommonWidgetHeader headerText={getWidgetHeaderText({ widgetTitle: translate('featuredVideos') })} />
                <FeaturedVideosWidgetBody />
            </CommonWidgetContainer>
        );
    }
    return (
        <CommonWidgetContainer href={widgetLinkURL}  onClick={handleWidgetClick}> 
            <CommonWidgetHeader headerText={getWidgetHeaderText({ widgetTitle: translate('featuredVideos') })} />
            <FeaturedVideosWidgetBody />
        </CommonWidgetContainer>
    );
});

FeaturedVideosWidgetView.displayName = 'FeaturedVideosWidgetView';
